import React from 'react';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import { StandardBtn, PremiumBtn } from 'rebook/apps/base/components/BtnSubscriptionIcon';

import styles from '../style.scss';


class ItemView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bookInfo: {
        name: '',
      },
    };
  }

  componentDidMount() {
    const { item, getBook } = this.props;
    if (typeof item === 'number') {
      fetchQuery(`/api/books/${item}`, { apiVersion: 4 })
        .then(({ data }) => {
          getBook && getBook(data);
          this.setState({
            bookInfo: data,
          });
        }).catch(
          ({ data, resp, error }) => {
            if (resp.status === 404) {
              this.setState({
                bookInfo: {
                  name: 'Данная книга не найдена',
                  absolute_url: '/catalog/',
                },
              });
            }
            else {
              Raven.captureMessage('failed to load review list book due to server error', {
                level: 'error',
                extra: {
                  status: resp.status,
                  response: data,
                  error,
                },
              });
              throw new Error('failed to load review list book detail due to server error');
            }
          },
        );
    }
  }

  render() {
    const { item, accordion } = this.props;
    if (typeof item === 'number') {
      return (
        <React.Fragment>
          {accordion
            ? <div className={styles.itemHeader}><strong>Книга</strong>&nbsp;«{this.state.bookInfo.name}»</div>
            :
            <div className={styles.linkContainer}>
              <a href={this.state.bookInfo.absolute_url} className={styles.link} alt={this.state.bookInfo.name}>
                <MultilineEllipsisText maxLinesCount={2}>{this.state.bookInfo.name}</MultilineEllipsisText>
              </a>
              <div className={styles.linkHover}>{this.state.bookInfo.name}</div>
            </div>
          }
        </React.Fragment>
      );
    }
    const itemList = {
      audio: <PremiumBtn width="32" height="32" />,
      standard: <StandardBtn width="28" height="28" />,
      pro: <PremiumBtn width="32" height="32" />,
    };
    return (
      <React.Fragment>
        <div>
          {itemList[item]}
        </div>
      </React.Fragment>
    );
  }
}

export default ItemView;
